//CRN_20260706 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { LocationWebhookConfigDTOe } from 'src/app/core/models/system/location-webhook/location-webhook-config.dto';
import { LocationWebhookTestResultDTO } from 'src/app/core/models/system/location-webhook/location-webhook-test-result.dto';
import { Observable, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class LocationWebhookConfigService {

  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getByCompanyId(companyId: number): Observable<LocationWebhookConfigDTOe> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;

                            return this.httpClientService.get<LocationWebhookConfigDTOe>(
                              environment.eSimApi
                              + eSimApiPaths.LocationWebhookConfig
                              + "/"
                              + companyIdEncSS);
                         })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public replayLastCountryChange(companyId: number): Observable<LocationWebhookTestResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;

                            return <Observable<LocationWebhookTestResultDTO>>this.httpClientService.post(
                                   environment.eSimApi
                                   + eSimApiPaths.LocationWebhookConfig
                                   + "/"
                                   + eSimApiPaths.LocationWebhookConfigReplayLastCountryChange
                                   + "/"
                                   + companyIdEncSS,
                                   {});
                         })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public save(companyId: number, config: LocationWebhookConfigDTOe): Observable<any> {
    try {
      const payload=JSON.stringify(config);

      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encCompanyResult: StringResultDTO) => {
                            const companyIdEncSS=encCompanyResult.result;

                            return this.encryptionService.encrypt_AesServerSideForWeb(payload)
                                   .pipe(
                                      switchMap((encResult: StringResultDTO) => {
                                                  const objectEncSS=encResult.result;

                                                  return this.httpClientService.post(
                                                    environment.eSimApi
                                                    + eSimApiPaths.LocationWebhookConfig
                                                    + "/"
                                                    + companyIdEncSS,
                                                    { objectEncSS: objectEncSS });
                                               })
                                   );
                         })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public testSend(companyId: number): Observable<LocationWebhookTestResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;

                            return <Observable<LocationWebhookTestResultDTO>>this.httpClientService.post(
                                   environment.eSimApi
                                   + eSimApiPaths.LocationWebhookConfig
                                   + "/"
                                   + eSimApiPaths.LocationWebhookConfigTestSend
                                   + "/"
                                   + companyIdEncSS,
                                   {});
                         })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
